export { default } from "./useVocabularySupport";
